module.exports = __webpack_public_path__ + "img/right-arrow3.2c471a75.svg";